import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";
import { recordInstanceQueryOptions } from "@/services/record";

/**
 * Thin Record instance layout under Asset workspace — soft prefetch for drawer tabs.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/records/$recordId",
)({
	params: {
		parse: (params) => ({
			recordId: z.string().parse(params.recordId),
		}),
	},
	beforeLoad: ({ location, params }) => {
		const normalized = location.pathname.replace(/\/$/, "");
		const exactRoot = normalized.endsWith(
			`/workspace/assets/${params.assetId}/workspace/records/${params.recordId}`,
		);
		if (exactRoot) {
			const q =
				typeof location.search === "object" &&
				location.search &&
				"q" in location.search &&
				typeof (location.search as { q?: unknown }).q === "string"
					? (location.search as { q: string }).q
					: undefined;
			throw redirect({
				to: "/web/$orgId/jobs/$jobId/workspace/assets/$assetId/workspace/records/$recordId/details",
				params: {
					orgId: params.orgId,
					jobId: params.jobId,
					assetId: params.assetId,
					recordId: params.recordId,
				},
				search: { q },
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.prefetchQuery(
			recordInstanceQueryOptions.detail(params.recordId, {
				organizationId: params.orgId,
			}),
		);
	},
	component: AssetScopedRecordIdLayout,
});

function AssetScopedRecordIdLayout() {
	return <Outlet />;
}
